import styled from "styled-components";
import {ButtonSubmit, getChatUserToken, postChatStart, sleep, T} from "./connector";
import {createChat} from "./tencent";
import {message} from "antd";
import {useState} from "react";
import {initTencentCall} from "../Call/tencent";

export const ChatButton = (props: {
    onSubmit?: (data: {
        chatSDK: any,
        callEngine: any,
        tencentUserId: string,
        tencentGroupId: string,
        endChatAt?: string,
        name?: string,
        threadId?: string
    }) => void,
    bookingId?: string,
    thread?: any,
}) => {
    const [loading, setLoading] = useState(false);

    const onStart = async () => {
        if (loading) return;
        if (props?.thread) {
            props?.onSubmit(props.thread);
            return;
        }

        setLoading(true);
        // let chatLocalSession = null;
        // try {
        //     if (window.location.href.includes('localhost')) {
        //         chatLocalSession = JSON.parse(window.localStorage.getItem("chat-local-session-" + props?.bookingId));
        //     }
        // } catch (e) {
        // }
        const resultStart = await postChatStart(props?.bookingId);
        const configLocal: any = {};
        try {
            window.localStorage.setItem("chat-local-session-" + props?.bookingId, JSON.stringify({
                status: resultStart?.status,
                data: resultStart?.data,
            }));
        } catch (e) {
        }

        if (resultStart?.status === 200) {
            configLocal.tencentGroupId = resultStart?.data?.data?.tencentGroupId;
            configLocal.tencentUserId = resultStart?.data?.data?.tencentCustomerUserId;
            configLocal.id = resultStart?.data?.data?.id;
            configLocal.endChatAt = resultStart?.data?.data?.endChatAt;
            configLocal.name = resultStart?.data?.data?.name;
            configLocal.threadId = resultStart?.data?.data?.threadId;
            // get token
            await sleep(500); // try to wait for 500ms, tencent delay create account
            const resultToken = await getChatUserToken(props?.bookingId, configLocal.tencentUserId);
            if (resultToken?.status === 200) {
                configLocal.appId = resultToken?.data?.data?.tencentSdkAppId;
                configLocal.token = resultToken?.data?.data?.userSig;

                // start chat
                const chat = await createChat({
                    appId: parseInt(configLocal.appId),
                    userId: configLocal.tencentUserId,
                    userSig: configLocal.token,
                });
                // Init call engine if needed
                const resultCall = await initTencentCall({
                    appId: parseInt(configLocal.appId),
                    userId: configLocal.tencentUserId,
                    userSig: configLocal.token
                });
                if (!!chat) {
                    props?.onSubmit({
                        chatSDK: chat,
                        callEngine: resultCall,
                        tencentUserId: configLocal.tencentUserId,
                        tencentGroupId: configLocal.tencentGroupId,
                        endChatAt: configLocal.endChatAt,
                        name: configLocal.name,
                        threadId: configLocal.threadId,
                    })
                } else {
                    message.error(T("Cannot access chat service!"));
                }
            } else {
                message.error(T("Cannot access chat service!"));
            }


        } else {
            message.error(T("Cannot start chat!"));
        }
        setLoading(false);

    }


    return (
        <Container onClick={onStart} loading={loading}>{T("Chat with us")}<Icon/></Container>
    )
}
const Container = styled(ButtonSubmit)`
    height: 56px;
    border-radius: 50px;
    background: #FFF !important;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    position: fixed !important;
    z-index: 1;
    bottom: 12px;
    right: 12px;
    width: auto;
    color: ${(props => props.theme.main)} !important;

    svg {
        margin-left: 6px;

        & * {
            fill: ${(props => props.theme.main)} !important;
        }
    }

    &.ant-btn-loading > svg {
        display: none;
    }
`;

const Icon = (props) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.8333 2.33301H8.16665C4.94665 2.33301 2.33331 4.93467 2.33331 8.14301V15.1197V16.2863C2.33331 19.4947 4.94665 22.0963 8.16665 22.0963H9.91665C10.2316 22.0963 10.6516 22.3063 10.85 22.563L12.6 24.8847C13.37 25.9113 14.63 25.9113 15.4 24.8847L17.15 22.563C17.3716 22.2713 17.7216 22.0963 18.0833 22.0963H19.8333C23.0533 22.0963 25.6666 19.4947 25.6666 16.2863V8.14301C25.6666 4.93467 23.0533 2.33301 19.8333 2.33301ZM15.1666 16.0413H8.16665C7.68831 16.0413 7.29165 15.6447 7.29165 15.1663C7.29165 14.688 7.68831 14.2913 8.16665 14.2913H15.1666C15.645 14.2913 16.0416 14.688 16.0416 15.1663C16.0416 15.6447 15.645 16.0413 15.1666 16.0413ZM19.8333 10.208H8.16665C7.68831 10.208 7.29165 9.81134 7.29165 9.33301C7.29165 8.85467 7.68831 8.45801 8.16665 8.45801H19.8333C20.3116 8.45801 20.7083 8.85467 20.7083 9.33301C20.7083 9.81134 20.3116 10.208 19.8333 10.208Z"
            fill="#1D896D"/>
    </svg>
)
